<div class="related-person">
  <div class="row middle-xs between-xs">
    <div class="col-no-gutter">
      <h4 class="related-person__title">{{form.value.name || label}}</h4>
    </div>
    <ng-container *ngIf="!readonly && removeLabel">
      <div class="col-sm-3 col-no-gutter">
        <mfp-button
          class="related-person__remove"
          color="secondary"
          [fill]="removeFill"
          [size]="removeSize"
          [icon]="removeIcon"
          [iconPosition]="removeIconPosition"
          [label]="removeLabel"
          (click)="remove()"
        ></mfp-button>
      </div>
    </ng-container>

  </div>
  <div [formGroup]="form">
    <div class="row">
      <div
        class="col-xs-24 col-gutter-lr col-sm-9"
      >
        <mfp-input
          type="text"
          [name]="nameName"
          [formControlName]="nameName"
          [view]="view"
          [label]="nameLabel"
          [placeholder]="namePlaceholder"
          [success]="isOptionalFieldSuccess(form, nameName)"
          [error]="isFieldInvalid(form, nameName)"
          [helper]="(isFieldInvalid(form, nameName) ? nameNotValidMessage : '')"
          [readonly]="readonly"
        ></mfp-input>
      </div>
      <div
        class="col-xs-24 col-xs--no-margin col-gutter-lr col-sm-6"
      >
        <mfp-input
          type="number"
          [name]="ageName"
          [formControlName]="ageName"
          [view]="view"
          [label]="ageLabel"
          [placeholder]="agePlaceholder"
          [success]="isFieldValid(form, ageName)"
          [error]="isFieldInvalid(form, ageName)"
          [helper]="getFieldError(form, ageName) | translate:ageErrorData"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input>
      </div>
    </div>
  </div>
</div>
